// extracted by mini-css-extract-plugin
module.exports = {"button":"_2f_0d"};